
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12562 2950.001 2.8 14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_25_3","data-name":"Symbol 25 – 3","transform":"translate(-18929 -1896.999)"}},[_c('g',{attrs:{"id":"Group_169","data-name":"Group 169","transform":"translate(4643 4083)","opacity":".34"}},[_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_34","cx":"1.4","cy":"1.4","r":"1.4","data-name":"Ellipse 34","transform":"rotate(90 481.4 1245.4)"}}),_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_35","cx":"1.4","cy":"1.4","r":"1.4","data-name":"Ellipse 35","transform":"rotate(90 478.6 1248.2)"}}),_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_36","cx":"1.4","cy":"1.4","r":"1.4","data-name":"Ellipse 36","transform":"rotate(90 475.8 1251)"}})])])])
          )
        }
      }
    